import userStore from "../zustand/userStore";
export const apiKey = "docmaster-apikey";
export const apiKeyValue = "abcdef12345";
export const apiKeyAddTo = "header";

export const apiKeyHeader = () => {
  const userData = userStore.getState().user;
  let header2Post = {};
  header2Post["content-type"] = "application/json";
  header2Post[apiKey] = apiKeyValue;
  header2Post["x-tenant-db"] = encodeURIComponent(userData?.db_name || "");
  header2Post["x-user-id"] = userData?.admin_id || "";
  return header2Post;
};

export const apiKeyHeaderMultiPartFormData = () => {
  const userData = userStore.getState().user;

  let header2Post = {};
  header2Post["Accept"] = "application/json";
  header2Post["content-type"] = "multipart/form-data";
  header2Post[apiKey] = apiKeyValue;
  header2Post["x-tenant-db"] = encodeURIComponent(userData?.db_name || "");
  header2Post["x-user-id"] = userData?.admin_id || "";
  return header2Post;
};

export const apiKeyHeaderWithUserId = () => {
  const userData = userStore.getState().user;

  let header2Post = {
    "content-type": "application/json",
    "x-tenant-db": apiKeyValue,
    user_id: userData?.db_name || "",
  };

  return header2Post;
};

export const apiKeyHeaderMultiPartFormData2 = () => {
  const userData = userStore.getState().user;

  let header2Post = {};
  header2Post["Accept"] = "application/json";
  header2Post[apiKey] = apiKeyValue;
  header2Post["x-tenant-db"] = encodeURIComponent(userData?.db_name || "");
  header2Post["x-user-id"] = userData?.admin_id || "";
  return header2Post;
};
